import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import OnPaymentMethodActionData from './onPaymentMethodAction_data.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Notifies you when a specific payment method has been selected or unselected.`}</p>
    <Group summary='Parameters' mdxType="Group">
	<Item title='action' subtitle='"PAYMENT_METHOD_SELECTED" | "PAYMENT_METHOD_UNSELECTED"' mdxType="Item">
		The action being performed on the payment method. Payment will be unselected when a popup is closed.
	</Item>
	<Item title='data' subtitle='object' mdxType="Item">
		<OnPaymentMethodActionData mdxType="OnPaymentMethodActionData" />
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      